import {
  Typography,
  ListItem,
  ListItemButton,
  ListItemText,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { SettingsSection } from '$common/settings-section'
import { t } from '$i18n'
import { showClearDbModal } from '$comp/modals/confirmation-dialog'
import { LabeledSwitch } from '$common/labeled-switch'
import { SettingsIntendedDivider } from '$common/settings-item'
import {
  setAutoDownload,
  setAutoPlay,
  useAutoDownload,
  useAutoPlayAudio,
} from '$logic/client-device'

const StyledListItemButton = styled(ListItemButton)`
  box-sizing: border-box;
  padding: 5px 25px 5px 20px;
`

export function SettingsStorage() {
  const isAutoDownloadEnabled = useAutoDownload()
  const isAutoPlayEnabled = useAutoPlayAudio()
  const toggleAutoDownload = () => {
    setAutoDownload(!isAutoDownloadEnabled)
    analite('PROFILE_SETTING_AUTO_DOWNLOAD', { active: !isAutoDownloadEnabled })
  }
  const toggleAutoPlay = () => {
    setAutoPlay(!isAutoPlayEnabled)
    analite('PROFILE_SETTING_CONTINUOUS_PLAYBACK', {
      active: !isAutoPlayEnabled,
    })
  }

  return (
    <SettingsSection headerText={t('settings.sections.storage.title')}>
      <>
        <ListItem disablePadding>
          <StyledListItemButton onClick={showClearDbModal}>
            <ListItemText
              primary={
                <Typography component="p" variant="body2">
                  {t('settings.sections.storage.clearStorage')}
                </Typography>
              }
              secondary={
                <Typography variant="caption1" color="gray">
                  {t('settings.sections.storage.description')}
                </Typography>
              }
            />
          </StyledListItemButton>
        </ListItem>
        <SettingsIntendedDivider />
        <LabeledSwitch
          label={t('settings.sections.storage.autoDownload')}
          checked={isAutoDownloadEnabled}
          onChange={toggleAutoDownload}
        />
        <SettingsIntendedDivider />
        <LabeledSwitch
          label={t('settings.sections.storage.autoPlay')}
          checked={isAutoPlayEnabled}
          onChange={toggleAutoPlay}
        />
        <SettingsIntendedDivider />
      </>
    </SettingsSection>
  )
}
